package com.londogard.partyplanner

import dev.fritz2.lenses.Lenses
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class ContactEntry(
    val name: String,
    val telephone: String? = null,
    val email: String? = null,
    val address: String? = null
)

@Lenses
@Serializable
data class ContactWrapper(val title: String = "", val entries: List<ContactEntry> = emptyList())

@Lenses
@Serializable
data class Contacts(val entries: List<ContactWrapper> = emptyList())

@Lenses
@Serializable
data class TimelineElement(val title: String, val description: String, val time: String, val timelineid: Long? = null)

@Lenses
@Serializable
data class Information(val content: String, val date: String, val timeline: List<TimelineElement> = emptyList())

@Lenses
@Serializable
data class RsvpGuest(val name: String, val isComing: Boolean = false)

@Lenses
@Serializable
data class Guest(
    val userid: Long = -1L, val guestid: Long = -1L, val rsvps: List<RsvpGuest> = emptyList(),
    val extra: Map<String, Boolean> = emptyMap(), val comment: String = ""
)

@Lenses
@Serializable
data class Gift(
    val title: String, val description: String, val img: String? = null,
    val links: List<String> = emptyList(), val checkable: Boolean = true,
    val checkedGiftById: List<Pair<Boolean, Long>> = emptyList()
)

@Lenses
@Serializable
data class GifteryList(val title: String, val description: String, val gifts: List<Gift> = emptyList())

@Lenses
@Serializable
data class Data(
    val contact: Contacts,
    val information: Information,
    val guests: List<Guest>,
    val gift: GifteryList,
    val weddingId: Long = -1L,
    val customMarkdownSections: Map<String, String>? = null
)